import gql from 'graphql-tag';

export default gql`
mutation insertPageTag($pageId: Int!, $tagId: Int!) {
  insert_pages_tags(objects: {tag_id: $tagId, page_id: $pageId}) {
    affected_rows
  }
}
`;
